import { makeStyles } from '@material-ui/core/styles';
import colors from '../../theme/colors';

export default makeStyles((theme) => ({
  header: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing(1)
  },
  headerSpaceBetween: {
    justifyContent: 'space-between',
  },
  selectedItemsContainer: {
    alignItems: 'center',
    backgroundColor: colors.SESAMSEC_SYS_LIGHT_SURFACE_CONTAINER_LOWEST,
    borderRadius : theme.spacing(1),
    display: 'flex',
    width: '100%',
    '& .MuiTypography-root': {
      paddingLeft: theme.spacing(2),
      color: colors.DARK_GRAY
    },
    '& .MuiIconButton-root': {
      padding: theme.spacing(1)
    },
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
      boxShadow      : 'none',
    },
    '& .MuiSvgIcon-root': {
      height: `${theme.spacing(3)}px !important`,
      width : `${theme.spacing(3)}px !important`,
      color: colors.DARK_GRAY_ICON
    }
  },
  actionsContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    borderRadius : theme.spacing(1),
    display      : 'flex',
    padding      : theme.spacing(1),
    width        : 'fit-content',
    paddingInline : theme.spacing(3),
    '& .MuiSvgIcon-root': {
      height: `${theme.spacing(3)}px !important`,
      width : `${theme.spacing(3)}px !important`,
    }
  },
  stickyTableCell: {
    backgroundColor: 'white',
    minWidth       : '0 !important',
    position       : 'sticky',
    zIndex         : 1
  },
  smallerTableCell: {
    position: 'sticky',
  },
  selectedStickyCell: {
    backgroundColor: colors.COMPONENT_STATE_HOVER,
  },
  paper: {
    marginBottom: theme.spacing(5),
    width       : '100%',
  },
  cutBar: {
    height   : '100%',
    position : 'relative',
  },
  root: {
    paddingLeft : theme.spacing(0.4),
    paddingRight: theme.spacing(1),
  },
  toolView: {
    display       : 'flex',
    height        : '100%',
    margin        : '0 auto',
    overflow      : 'hidden',
    position      : 'relative'
  },
  toolbar: {
    paddingLeft  : theme.spacing(0),
    paddingRight : theme.spacing(0)
  },
  toolBarItemsContainer: {
    alignItems: 'center'
  }, 
  endToolBarItemsContainer: {
    alignItems    : 'center',
    justifyContent: 'space-between'
  }, 
  enhancePagination: {
    width: '100%',
    padding: theme.spacing(0),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    position: 'relative',
    '& .MuiTablePagination-root': {
      width: '100%'
    },
    '& .MuiTablePagination-toolbar': {
      width: '100%'
    },
    '& .MuiTablePagination-caption': {
      position: 'absolute',
      left: 0
    },
  },
  enhancePreviousButton: {
    position: 'absolute',
    right: 100,
    zIndex: 100
  },
  enhancePaginationSkeleton: {
    position: 'absolute',
    left: 0
  },
  paginationContainer: {
    alignItems    : 'center',
    display       : 'flex',
    justifyContent: 'right',
    position      : 'relative',
    '& .MuiSkeleton-root' : {
      position: 'absolute',
      right   : theme.spacing(15)
    },
    '& .MuiTablePagination-caption': {
      color: colors.LIGHT_GRAY_TEXT
    }
  },
  paginationHide: {
    '& .MuiTablePagination-caption': {
      display: 'none'
    }
  },
  pagination: {
    alignItems   : 'center',
  },
  searchField: {
    display : 'block',
    float   : 'left',
    margin  : 0,
    position: 'relative',
    top     : theme.spacing(-0.5),
    '& .MuiInputBase-root': {
      height: theme.spacing(5.625)
    }
  },
  activeIcon: {
    color        : colors.DARK_GRAY,
    flexWrap     : 'nowrap',
    fontSize     : theme.spacing(2),
    fontWeight   : '800',
    marginBottom : theme.spacing(-.2),
    marginRight  : theme.spacing(.5),
  },
  inactiveIcon: {
    color        : theme.palette.secondary.main,
    flexWrap     : 'nowrap',
    fontSize     : theme.spacing(2),
    fontWeight   : '800',
    marginBottom : theme.spacing(-.2),
    marginRight  : theme.spacing(.5),
    opacity      : '16%'
  },
  columnHeader: {
    alignContent  : 'center',
    alignItems    : 'center',
    display       : 'contents',
    justifyContent: 'center',
  },
  columnItem: {
    color     : colors.LIGHT_GRAY_TEXT,
    flexWrap  : 'nowrap',
    fontSize  : theme.spacing(1.75),
    fontWeight: '400'
  },
  baseCell: {
    maxWidth     : '3vw',
    minWidth     : theme.spacing(25),
    overflow     : 'hidden',
    padding      : 0,
    paddingLeft  : theme.spacing(2),
    paddingRight : theme.spacing(2),
    textOverflow : 'ellipsis',
    whiteSpace   : 'nowrap', 
    '& .MuiLink-root': {
      color: colors.BLACK
    }
  },
  dataRow: {
    cursor: 'pointer',
    height: theme.spacing(7)
  },
  dataRowHover: {
    backgroundColor : colors.COMPONENT_STATE_HOVER,
    cursor          : 'pointer',
    height          : theme.spacing(7),
    '& $stickyTableCell': {
      backgroundColor: colors.COMPONENT_STATE_HOVER, 
    }
  },
  selectedRow: {
    backgroundColor: colors.COMPONENT_STATE_HOVER,
  },
  headerStyle: {
    backgroundColor: colors.WHITE,
    height         : theme.spacing(7),
    padding        : theme.spacing(0),
    paddingLeft    : theme.spacing(2),
    position       : 'sticky',
    textAlign      : 'left',
    top            : 0,
    zIndex         : 3,
  },
  smallerTableHead: {
    backgroundColor: colors.WHITE,
    height         : theme.spacing(7),
    padding        : theme.spacing(0),
    paddingLeft    : theme.spacing(2),
    position       : 'sticky',
    textAlign      : 'left',
    top            : 0,
    zIndex         : 3,
  },
  icon: {
    height: `${theme.spacing(3)}px !important`,
    width : `${theme.spacing(3)}px !important`,
    color : colors.DARK_GRAY_ICON
  },
  visuallyHidden: {
    border  : 0,
    clip    : 'rect(0 0 0 0)',
    height  : 1,
    margin  : -1,
    overflow: 'hidden',
    padding : 0,
    position: 'absolute',
    top     : 20,
    width   : 1,
  },
  mainTable: {
    borderCollapse: 'unset'
  },
  stickyMainTable: {
    borderCollapse: 'unset',
    tableLayout   : 'auto'
  },
  tableBox: {
    width: '100%',
    height: '85.5%',
    '@media (max-height: 720px)' : {
        height: '75%'
    },
    '@media (max-height: 540px)' : {
        height: '73%'
    },
    '@media (max-height: 460px)' : {
        height: '63%'
    }
  },
  fixedTableBox: {
    width : '100%',
    height: '100%',
    '@media (max-height: 720px)' : {
        height: '75%'
    },
    '@media (max-height: 540px)' : {
        height: '70%'
    },
    '@media (max-height: 460px)' : {
        height: '60%'
    }
  },
  stickyColumns: {
    height         : '100%',
    minWidth       : theme.spacing(37.5),
    overflow       : 'auto',
    scrollbarWidth : 'none',
    width          : '30%',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  fixedStickyColumns: {
    height         : '100%',
    minWidth       : theme.spacing(37.5),
    overflow       : 'auto',
    scrollbarWidth : 'none',
    width          : '30%',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  nonStickyColumns: {
    height  : '100%',
    flex    : 1,
    overflow: 'auto',
    scrollbarWidth : 'thin',
  },
  fixedNonStickyColumns: {
    height    : '100%',
    flex      : 1,
    overflowX : 'auto',
    overflowY : 'hidden'
  },
  divider: {
    borderRight   : '2px solid ' + colors.LIGHT_GRAY,
    paddingBottom : theme.spacing(1.875),
  },
  timeColumn: {
    width   : theme.spacing(11),
    maxWidth: 'fit-content'
  },
  title: {
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '22px'
  },
  filterContainer: {
    paddingTop: theme.spacing(-1)
  },
  actionButtonCell: {
    display: 'flex'
  },
  actionButton: {
    color       : colors.DARK_GRAY_ICON,
    marginLeft  : theme.spacing(1.5),
    marginRight : theme.spacing(1.5),
    padding     : 0,
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow      : 'none',
    }
  },
  customTooltip: {
    backgroundColor: colors.TOOLTIP_DARK_GRAY,
    borderRadius   : theme.spacing(0.25),
    color          : colors.WHITE,
    fontSize       : theme.spacing(1.75),
    textAlign      : 'center'
  },
  credentialsCell: {
    padding: 0,
    width: theme.spacing(10),
    minWidth: `${theme.spacing(10)}px !important`,
  },
  inactiveRow: {
    visibility: 'hidden'
  }
}));